export default "https://fiverr-res.cloudinary.com/npm-assets/@fiverr/search_perseus/apps/flyer_distribution.69807cc.svg";